import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import PaymentTable from './DepositTable'
import{Box} from '@chakra-ui/react';

const Liability = () => {
    return (
        <div>
            <HeaderSection
                title="View Deposit"
                breadcrumb={["Dashboard", "Voucher", "Deposit"]}
            />
            <Box p={6}>

                <PaymentTable />
            </Box>
        </div>
    )
}

export default Liability